import { Routes } from '@angular/router';

export const reviewConversionRoutes: Routes = [
  {
    path: 'share-review',
    data: {
      robots: 'noindex, nofollow',
    },
    children: [
      {
        path: ':convertReviewCode',
        loadChildren: () => import('@rma/public/reviews/convert-review-flow'),
      },
      {
        path: ':convertReviewCode/opt-out',
        loadChildren: () => import('@rma/public/reviews/convert-review-flow'),
      },
      {
        path: ':verticalType/referral/:referralCode',
        loadChildren: () => import('@rma/public/reviews/convert-review-flow'),
      },
      {
        path: ':verticalType/referral/:referralCode/opt-out',
        loadChildren: () => import('@rma/public/reviews/convert-review-flow'),
      },
      {
        path: ':verticalType/:convertReviewCode',
        loadChildren: () => import('@rma/public/reviews/convert-review-flow'),
      },
      {
        path: ':verticalType/:convertReviewCode/opt-out',
        loadChildren: () => import('@rma/public/reviews/convert-review-flow'),
      },
    ],
  },
];
